import { Component, OnInit, Input, Output, EventEmitter, forwardRef, ChangeDetectorRef, OnDestroy, ElementRef, ViewChild,
  } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormConstants } from '../../../core/globals/form-constants';
import { BaseControlValueAccessor } from '../base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { GoogleMapsService } from '../../services/google-maps.service';
import { mapStyle } from '../../constants/mapStyle';

declare const google: any;

@Component({
  selector: 'app-location-search',
  templateUrl: './location-search.component.html',
  styleUrls: ['../../styles/form-input.scss', './location-search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationSearchComponent),
      multi: true
    }
  ]
})
export class LocationSearchComponent
  extends BaseControlValueAccessor<any>
  implements OnInit, OnDestroy
{
  @ViewChild("mapContainer") mapContainer: ElementRef;

  @Input() config: any;
  @Input() showClear: boolean;
  @Input() formControl: FormControl;
  @Input() getLocationLabel: (arg0: any) => string;
  @Input() showSavedLocationOnly: boolean;
  @Input() type: 'googleAddress' | 'googleAddressAndInput';
  @Input() styleApplied: string;

  @Output() changeCallback = new EventEmitter();

  public canSearch: boolean;
  public placeholder: string;
  public canAdd: boolean;
  public isListShown = false;
  public selectOptions = [];
  private searchQuery: string;
  public displayValue: string;
  public value: any;
  public cityName: string;
  private optionsFetchThrottleTimer: any;
  private optionsFetchSubscription: any;
  private watcher: any;
  private savedLocationsList: any[] = [];
  public errorMessages = FormConstants.errorMessages;
  public showGoogleAttribution: boolean;
  public activeOption: any;
  public imgVisibility = true;
  openMap = false;
  map: any;
  currentLat: number;
  currentLong: number;
  marker: any;
  selectedAddress: any;
  displayAddress = '';
  showAddressList = false;
  centerEvent: any;
  disbaleIcon: any;


  constructor(private googleMapsService: GoogleMapsService,
              private changeDetectorRef: ChangeDetectorRef, private elementRef: ElementRef) {
    super();
  }

  @Input()
  set city(city: string) {
    this.cityName = city;
    this.fetchOptions();
  }

  @Input()
  set savedLocations(locations: any[]) {
    if (JSON.stringify(this.savedLocationsList) !== JSON.stringify(locations)) {
      this.savedLocationsList = locations;
      this.fetchOptions();
    }
  }

  ngOnInit() {
    /** Newly added */
    if ((this.type === 'googleAddress' || this.type === 'googleAddressAndInput') &&
      (this.styleApplied === 'booking-trip-location-search' || this.styleApplied === 'booking-trip-location-search')) {
      this.imgVisibility = false;
    }


    this.setOptions();
    this.selectOptions = this.savedLocationsList || [];
    if (this.formControl) {
      this.setValue(this.formControl.value);
      this.setDisplayValue();
      this.watcher = [
        this.formControl.valueChanges.subscribe(this.setFormControlValue.bind(this))
      ];
          }
  }

  setFormControlValue = () => {
        if (this?.value?.address)
    {
      this.setDisplayValue();
    }
        if (!this.value && this.displayValue) {
      this.setDisplayValue();
      this.searchQuery = '';
      this.fetchOptions();
    }
  }

  setDisplayValue(): void {
    if (!this.value) {
      this.displayValue = '';
    } else {
      this.displayValue = this.getOptionLabel(this.value);
    }
  }

  setValue(value: any) {
    this.value = value ;
    this.onChange(this.value);
    if (this.changeCallback) {
      this.changeCallback.emit(this.value);
    }
  }

  onOptionClick(option: any): void {
    this.isListShown = false;
    if (this.openMap) { this.showAddressList = false; }
    if(option){
      if (option.isSaved) {
        this.handleOptionChange(option);
      } else {
        if (this.openMap){
          this.displayAddress = "";
          if (this.selectedAddress?.description) { this.selectedAddress.description = option?.description; }
          this.googleMapsService
          .getPlaceGeoCode(option.place_id)
          .subscribe((geoCord) => {
            option.geoCord = geoCord;
            const lat = Number(option.geoCord.split(',')[0]);
            const long = Number(option.geoCord.split(',')[1]);
            this.marker.setPosition(new google.maps.LatLng(lat, long));
            this.marker.setMap(this.map);
            this.map.setCenter(new google.maps.LatLng(lat, long));
            this.map.setZoom(18);
            this.reverseGeocode(this.map.getCenter());
          });
              }
        else{
          this.displayValue = option.description;
          this.googleMapsService.getPlaceGeoCode(option.place_id).subscribe((geoCord) => {
            option.geoCord = geoCord;
            this.handleOptionChange(option);
          });
                }
      }
    }
  }

  handleOptionChange(option) {
    this.setValue(this.getOptionValue(option));
    this.setDisplayValue();
    this.hideList();
    this.searchQuery = '';
  }

  getOptionValue(option: any): string {
    return option.isSaved ? option : {
          address: option.description,
          addressType: option?.structured_formatting?.main_text,
          geoCord: option.geoCord,
          isSaved: true
        };
  }

  getOptionLabel(option: any): string {
    return  option.isSaved ? this.getLocationLabel(option) : option;
  }

  setOptions(): void {
    switch (this.type) {
      case 'googleAddress':
        this.canAdd = false;
        this.placeholder = this.placeholder || 'Search';
        break;
      case 'googleAddressAndInput':
        this.canAdd = true;
        this.placeholder = this.placeholder || 'Search or enter';
        break;
      default: console.warn('Incorrect location search type', this.type);
    }
  }

  handleTriggerClick() {
        if (!this.formControl || !this.formControl.disabled) {
      this.fetchOptions();
      this.isListShown ? this.hideList() : this.showList();
    }
  }

  handleInputChange(event) {
    this.searchQuery = this.displayValue;
    this.fetchOptions();
    if (this.canAdd) {
      this.setValue(this.getValueFromDisplayValue());
    }

    if (event && event.keyCode === 13 && typeof this.activeOption === 'number') {
      this.onOptionClick(this.selectOptions[this.activeOption]);
      this.hideList();
    } else if (event.keyCode === 13 && this.isListShown) {
      this.hideList();
    } else if (!event || event.keyCode !== 27) {
      this.showList();
    }
  }

  searchAddress(event){
    this.displayAddress = event;
    if (event.length > 2) {
      this.optionsFetchSubscription = this.googleMapsService
        .findPlaceFromQuery(event)
        .subscribe((result) => {
          this.selectOptions = [];
          this.selectOptions = this.selectOptions.concat(result);
          this.optionsFetchSubscription = null;
          this.showAddressList = true;
          this.changeDetectorRef.detectChanges();
        });
    }
  }

  checkInput(event) {
    // enter key triggers a click outside event by default
    if (event.keyCode === 13) {
      event.preventDefault();
    }
    return ((event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 64 && event.charCode <= 90) || ((event.charCode >= 44 && event.charCode <= 57)) || (event.charCode == 32) || (event.charCode == 45));
  }

  getValueFromDisplayValue(): any {
    return this.canAdd ? {address: this.displayValue} :  '';
  }

  handleInputBlur() {
    if (!this.displayValue) {
      this.setValue(null);
    } else if (!this.canAdd && !this.value && this.displayValue) {
      this.displayValue = '';
      this.searchQuery = '';
    } else if (!this.canAdd && this.value) {
      this.displayValue = this.getOptionLabel(this.value);
    }
  }

  filterSavedLocations(): any {
    this.showGoogleAttribution = false;
    if (this.savedLocationsList) {
      return this.savedLocationsList.filter((location) => {
        const locationInCity = this.cityName && location.city ? location.city === this.cityName : true;
        if (locationInCity) {
          return true;
        }
        return false;
      });
    } else {
      return [];
    }
  }

  fetchOptions() {
        if (!this.searchQuery || this.searchQuery.length <= 2) {
      setTimeout(() => {
        this.selectOptions = this.filterSavedLocations();
        this.disbaleIcon = this.selectOptions.some(address => address.isAirport || address.isBusRailway);
      }, 100);
      if (this.optionsFetchThrottleTimer) {
        clearTimeout(this.optionsFetchThrottleTimer);
        this.optionsFetchThrottleTimer = null;
      }
      if (this.optionsFetchSubscription) {
        this.optionsFetchSubscription.unsubscribe();
      }
      return;
    }
        if (this.searchQuery.length > 2) {
      if (this.optionsFetchThrottleTimer) {
        return;
      }
      this.optionsFetchThrottleTimer = setTimeout(() => {
        if (this.optionsFetchSubscription) {
          this.optionsFetchSubscription.unsubscribe();
        }
        this.selectOptions = this.filterSavedLocations().filter((location) => {
                    if ((location.address + location.type).toLowerCase().indexOf(this.searchQuery) > -1) {
            return true;
          }
                    return false;
        });
        if (!this.showSavedLocationOnly && this.searchQuery.length > 2) {
          this.optionsFetchSubscription = this.googleMapsService.findPlaceFromQuery(this.searchQuery, this.cityName)
            .subscribe((result) => {
              this.selectOptions = this.selectOptions.concat(result);
              this.optionsFetchSubscription = null;
              this.showGoogleAttribution = true;
              this.changeDetectorRef.detectChanges();
            });
        }
        clearTimeout(this.optionsFetchThrottleTimer);
        this.optionsFetchThrottleTimer = null;
      }, 300);
    }
  }

  showList() {
    this.isListShown = true;
  }

  hideList() {
    this.isListShown = false;
    this.activeOption = undefined;
  }

  clickOutside() {
    this.isListShown = false;
  }

  clearInput(event) {
    event.stopPropagation();
    this.setValue('');
  }


  setHighlightedOption(event) {
    if (event && event.keyCode === 40) {
      event.preventDefault();
      this.activeOption = (typeof this.activeOption === 'number' && this.activeOption < this.selectOptions.length - 1)
          ? (this.activeOption + 1) : 0;
      this.scrollToActiveOption();
    } else if (event && event.keyCode === 38) {
      event.preventDefault();
      this.activeOption = (typeof this.activeOption === 'number' && this.activeOption > 0)
          ? (this.activeOption - 1) : this.selectOptions.length - 1;
      this.scrollToActiveOption();
    } else if (event && (event.keyCode === 9 || event.keyCode === 27)) {
      this.hideList();
    }
  }

  scrollToActiveOption() {
    const parent = this.elementRef.nativeElement;
    parent.getElementsByClassName('select-option')[this.activeOption].scrollIntoView({block: 'nearest'});
  }


  showError(): boolean {
    return Boolean(this.formControl && this.formControl.errors && this.formControl.dirty);
  }
  checkKeys(event){
    return ((event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 64 && event.charCode <= 90) || ((event.charCode >= 48 && event.charCode <= 57)) || (event.charCode == 32) || (event.charCode == 39)  || (event.charCode >= 44 && event.charCode <= 47 ));
  }
  validateInput(event) {
    const clipboardData = event.clipboardData || window.Clipboard;
    const pastedText = clipboardData.getData('text');
    const specialCharsRegex = /[!#$%^&*()?":{}|<>]/;
    if (specialCharsRegex.test(pastedText)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  setMap() {
    this.openMap = true;
    this.changeDetectorRef.detectChanges();
    this.getLocation();

    const infoWindow = new google.maps.InfoWindow({
      content: '<div style="font-weight: 700;color:#181f33; margin-bottom:10px; text-align: center;">This would be your address.</div>Drag the pin accurately on the map',
      disableAutoPan: true,
    });

    this.map = new google.maps.Map(document.getElementById('map-container'), {
      zoom: 12,
      center: new google.maps.LatLng(this.currentLat, this.currentLong),
      disableDefaultUI: true,
      zoomControl: true,
      styles: mapStyle,
    });

    infoWindow.addListener('domready', () => {
      const infoWindowContent = document.querySelector('.gm-style-iw') as HTMLElement;
      if (infoWindowContent) {
        infoWindowContent.style.padding = '16px';
        infoWindowContent.style.fontSize = '12px';
        infoWindowContent.style.fontWeight = '700';
      }
    });

    google.maps.event.addListener(this.map, 'zoom_changed', () => {
      window.setTimeout(() => {
        this.marker.setPosition(this.map.getCenter());
        this.reverseGeocode(this.map.getCenter());
      }, 100);
      infoWindow.open(this.map, this.marker);
    });

    google.maps.event.addListener(this.map, 'dragstart', () => {
      this.centerEvent = google.maps.event.addListener(this.map, 'center_changed', () => {
        this.smoothTransition(this.marker, this.marker.getPosition(), this.map.getCenter());
      });
    });

    google.maps.event.addListener(this.map, 'dragend', () => {
      this.centerEvent.remove();
      this.marker.setPosition(this.map.getCenter());
      this.reverseGeocode(this.map.getCenter());
    });

    this.marker = new google.maps.Marker({
      position: new google.maps.LatLng(this.currentLat, this.currentLong),
      icon: {
        url: 'assets/map_marker.svg',
        scaledSize: new google.maps.Size(46, 46),
        anchor: new google.maps.Point(23, 56),
      },
      optimized: true,
      zIndex: 20,
      map: this.map,
      animation: google.maps.Animation.DROP,
    });
  }


  smoothTransition(marker, startPosition, endPosition) {
    const frames = 65;
    let frameCount = 35;
    function moveMarker() {
      frameCount++;

      const lat = startPosition.lat() + (endPosition.lat() - startPosition.lat()) * frameCount / frames;
      const lng = startPosition.lng() + (endPosition.lng() - startPosition.lng()) * frameCount / frames;
      marker.setPosition(new google.maps.LatLng(lat, lng));

      if (frameCount < frames) {
        requestAnimationFrame(moveMarker);
      }
    }
    moveMarker();
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          if (position) {
            this.currentLat = position.coords.latitude;
            this.currentLong = position.coords.longitude;

            this.marker.setMap(null);
            new google.maps.Marker({
              position: new google.maps.LatLng(this.currentLat, this.currentLong),
              icon: {
                url: "assets/currentLocation.svg",
                scaledSize: new google.maps.Size(30, 30),
              },
              optimized: true,
              zIndex: 20,
              map: this.map,
              animation: null,
            });
            this.marker.setPosition(new google.maps.LatLng(this.currentLat, this.currentLong));
            this.marker.setMap(this.map);
            this.map.setCenter(new google.maps.LatLng(this.currentLat, this.currentLong));
            this.map.setZoom(15);
          }
        },
        (error: GeolocationPositionError) => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.error("User denied the request for Geolocation.");
              break;
            case error.POSITION_UNAVAILABLE:
              console.error("Location information is unavailable.");
              break;
            case error.TIMEOUT:
              console.error("The request to get user location timed out.");
              break;
            default:
              console.error("An unknown error occurred.");
              break;
          }
        },
        { enableHighAccuracy: true }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }


  reverseGeocode(loc: any) {
    const geocoder = new google.maps.Geocoder();
    const latLng = loc;
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
       const latitude = results[0].geometry.location.lat();
       const longitude = results[0].geometry.location.lng();
       this.selectedAddress = {
        description: results[0].formatted_address,
        geoCord: `${latitude },${longitude}`,
        place_id: results[0].place_id,
        isSaved: false
       };
      } else {
        console.error("Geocoding failed:", status);
      }
    });
  }

  addAddress(){
       this.openMap = false;
       this.onOptionClick(this.selectedAddress);
  }

  ngOnDestroy() {
    if (this.watcher) {
      for (const watcher of this.watcher) {
        watcher.unsubscribe();
      }
    }
  }

}
